/**
 * Main Entry Point for City Planner Application
 * 
 * This file initializes the application and sets up the core components.
 */

import { MainApp } from './ui/MainApp.js';

/**
 * Initialize hamburger menu functionality
 */
function initHamburgerMenu() {
    const hamburgerToggle = document.getElementById('hamburger-toggle');
    const scriptLinks = document.getElementById('gfunkyscripts');
    const dropdowns = document.querySelectorAll('.site-header .dropdown');
    
    if (hamburgerToggle && scriptLinks) {
        // Toggle menu
        hamburgerToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            const isActive = hamburgerToggle.classList.toggle('active');
            scriptLinks.classList.toggle('active');
            // Add/remove body class for overlay
            if (isActive) {
                document.body.classList.add('menu-open');
            } else {
                document.body.classList.remove('menu-open');
            }
        });
        
        // Close menu when clicking outside
        document.addEventListener('click', (e) => {
            if (!scriptLinks.contains(e.target) && !hamburgerToggle.contains(e.target)) {
                hamburgerToggle.classList.remove('active');
                scriptLinks.classList.remove('active');
                document.body.classList.remove('menu-open');
                // Also close dropdowns
                dropdowns.forEach(dropdown => dropdown.classList.remove('active'));
            }
        });
        
        // Handle dropdown toggles in mobile menu
        dropdowns.forEach(dropdown => {
            const toggle = dropdown.querySelector('.dropdown-toggle');
            if (toggle) {
                toggle.addEventListener('click', (e) => {
                    // Only handle click for mobile menu (when script-links is active)
                    if (window.innerWidth <= 768) {
                        e.preventDefault();
                        e.stopPropagation();
                        dropdown.classList.toggle('active');
                    }
                });
            }
        });
        
        // Close menu when clicking a link
        const menuLinks = scriptLinks.querySelectorAll('a');
        menuLinks.forEach(link => {
            link.addEventListener('click', () => {
                hamburgerToggle.classList.remove('active');
                scriptLinks.classList.remove('active');
                document.body.classList.remove('menu-open');
                dropdowns.forEach(dropdown => dropdown.classList.remove('active'));
            });
        });
    }
}

/**
 * Initialize the application when DOM is ready
 */
document.addEventListener('DOMContentLoaded', () => {
    console.log('City Planner - Initializing...');
    
    // Initialize hamburger menu
    initHamburgerMenu();
    
    // Hide loading message
    const loadingEl = document.getElementById('loading');
    if (loadingEl) {
        loadingEl.style.display = 'none';
    }
    
    try {
        // Initialize the main application
        const app = new MainApp();
        app.init();
        
        console.log('City Planner - Initialized successfully');
    } catch (error) {
        console.error('Failed to initialize City Planner:', error);
        
        // Show error message to user
        const appEl = document.getElementById('app');
        if (appEl) {
            appEl.innerHTML = `
                <div style="padding: 20px; text-align: center;">
                    <h2>Error Loading Application</h2>
                    <p>Failed to initialize City Planner. Please refresh the page.</p>
                    <p style="color: #ff6666; font-size: 12px;">${error.message}</p>
                </div>
            `;
        }
    }
});

